import { GraphSchema } from '@ta/server';

import { Owner as OwnerDto, ownerBrutProps } from 'src/app/services/user/dto/owner';

import { User } from './user';

export interface Owner extends OwnerDto {
  id: string;
  user?: User;
  globalNote: number;
}

const props: (keyof Owner)[] = ['user', 'globalNote'];

export const ownerProps = new GraphSchema<Owner>(props.concat(ownerBrutProps));
